module.exports = __webpack_public_path__ + "img/arrow-base.8853ef2a.png";